/**
 * 音频播放器
 *
 * 管理:
 * 1. 音频队列
 * 2. PCM播放
 */

import PCMEngine from "./PCMEngine";

export default class AudioPlayer {

    constructor() {
        this.engine = new PCMEngine();
    }

    /**
     * 播放音频数据
     */
    push(buffer) {
        this.engine.push(buffer);
    }

    /**
     * 设置播放完毕回调
     */
    setOnDrainedCallback(callback) {
        this.engine.onDrained = callback;
    }

    /**
     * 恢复音频上下文
     */
    resume() {
        this.engine.resume();
    }

    /**
     * 停止
     */
    stop() {
        this.engine.stop();
    }

    /**
     * 关闭
     */
    close() {
        this.engine.close();
    }
}
